import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { Respuesta } from '../_models/shared/_index';
import { Router } from '@angular/router';
import { SessionService } from './session.service';
import { FiltroClasificacion } from '../_models/shared/filtro-clasificacion';
import { Clasificacion } from '../_models/shared/clasificacion';
import { ErrorService } from './error.service';

@Injectable()
export class ClasificacionService {
	constructor(
		private http: HttpClient,
		private router: Router,
		private errorService: ErrorService
	) { }

	private getModelosAgrupadosUrl: string =
		environment.rest + '/Clasificacion/GetModelosAgrupados';
	private getMarcasUrl: string = environment.rest + '/Clasificacion/GetMarcas';

	private getHijosUrl: string = environment.rest + '/Clasificacion/GetHijos';
	private getVersionesUrl: string =
		environment.rest + '/Clasificacion/GetVersiones';
	private getFotografiasModeloUrl: string =
		environment.rest + '/Clasificacion/GetFotografiasModelo';
	private addClasificacionUrl: string =
		environment.rest + '/Clasificacion/AddClasificacion';
	private editClasificacionUrl: string =
		environment.rest + '/Clasificacion/EditClasificacion';
	private delClasificacionUrl: string =
		environment.rest + '/Clasificacion/DelClasificacion';
	private getClasificacionByIdUrl: string =
		environment.rest + '/Clasificacion/GetClasificacionById';
	private getLogosMarcasUrl: string =
		environment.rest + '/Clasificacion/GetLogosMarca';

	private getClasificacionUrl: string = environment.rest + '/Clasificacion/GetClasificacion';

	private getClasificacionesByIdsUrl: string = environment.rest + '/Clasificacion/GetClasificacionesByIds';

	private moverNodoTMMUrl: string = environment.rest + '/Clasificacion/MoverNodoTMM';
	private getClasificacionesGeneralesUrl: string = environment.rest + '/Clasificacion/GetClasificacionesGenerales';

	public onVersionAgregada = new Subject();

	headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	getHijos(
		idPadre: number,
		filtroClasificacion: FiltroClasificacion
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getHijosUrl,
				{ idPadre, filtroClasificacion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(this.errorService.handleError<Respuesta>(`POST getHijos`))
			);
	}

	getVersiones(
		idUltimaClasificacion: number,
		filtroVersion: any
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getVersionesUrl,
				{ idUltimaClasificacion, filtroVersion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST getVersiones`)
				)
			);
	}

	getFotografiasModelo(
		idModelo: number,
		width: number,
		height: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getFotografiasModeloUrl,
				{ idModelo, width, height },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST getFotografiasModelo`)
				)
			);
	}

	addClasificacion(clasificacion: Clasificacion): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.addClasificacionUrl, { clasificacion }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST addClasificacion`)
				)
			);
	}

	editClasificacion(clasificacion: Clasificacion): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.editClasificacionUrl, { clasificacion }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST editClasificacion`)
				)
			);
	}

	delClasificacion(clasificacion: Clasificacion): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.delClasificacionUrl, { clasificacion }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST delClasificacion`)
				)
			);
	}

	getMarcas(activos: boolean): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getMarcasUrl, { activos }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(this.errorService.handleError<Respuesta>(`POST getMarcas`))
			);
	}

	getModelosAgrupados(activos: boolean): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getModelosAgrupadosUrl, { activos }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST getModelosAgrupados`)
				)
			);
	}

	getClasificacion(idModelo, filtroClasificacion): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getClasificacionUrl, { idModelo, filtroClasificacion }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>('POST getClasificacion')
				)
			);
	}

	getClasificacionesByIds(idsClasificaciones: number[]): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getClasificacionesByIdsUrl, { idsClasificaciones }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>('POST getClasificacion')
				)
			);
	}

	moverNodoTMM(idPadre, idClasificacion): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.moverNodoTMMUrl, { idPadre, idClasificacion }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>('POST moverNodoTMM')
				)
			);
	}

	getLogosMarcas(idsMarcas): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getLogosMarcasUrl, { idsMarcas }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>('POST moverNodoTMM')
				)
			);
	}

	getClasificacionesGenerales(idClasificacion: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.post<Respuesta>(this.getClasificacionesGeneralesUrl, {idClasificacion}, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(this.errorService.handleError<Respuesta>(`get getClasificacionesGenerales`))
		);
	}

	private handleError<T>(operation = 'operation') {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			//   this.router.navigate(['error-404',{codigoError:404}]);
			this.router.navigate(['error-404'], {
				queryParams: {
					codigoError: error.error.Code,
					mensaje: error.error.Message,
				},
			});

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
